/* eslint-disable import/no-mutable-exports, class-methods-use-this */
class Logger {
  constructor() {
    this.levels = ['log', 'info', 'warn', 'error'];
    this.level = process.env.LOG_LEVEL || 'error';
  }

  getLogger() {
    let levelFound = false;
    const log = {};

    this.levels.forEach(currentLevel => {
      if (currentLevel === this.level || levelFound) {
        levelFound = true;
        log[currentLevel] = console[currentLevel]; //eslint-disable-line
      } else {
        log[currentLevel] = () => {
          /* default log handler */
        };
      }
    });
    return log;
  }
}

const logger = new Logger();

module.exports = logger.getLogger();
